<template>
  <div class="prefix props-group">
    <el-form-item label="编码前缀">
      <div class="formula" contenteditable="true" v-html="expressionShow" @focus="focus($event)"></div>
    </el-form-item>
    <el-form-item label="编码起始"
      prop="properties.code.startNumber"
      :rules="{validator: validateNumber, options:{startNumber:this.component.properties.code.startNumber,length:component.properties.code.length}, trigger: 'blur'}">
      <el-input v-model="component.properties.code.startNumber" type="number" min="0"/>
    </el-form-item>
    <el-form-item label="编码位数"
     prop="properties.code.startNumber"
      :rules="{validator: validateCodeLength, options:{length:this.component.properties.code.length}, trigger: 'blur'}">
      <el-input v-model="component.properties.code.length" type="number" min="0"/>
    </el-form-item>
    <el-form-item label="编码展示">
      <el-input v-model="show" title="当前展示编码非最终编码" disabled/>
    </el-form-item>
    <el-form-item label="按前缀编码">
      <el-checkbox v-model="component.properties.code.isPrefix"></el-checkbox>
    </el-form-item>
    <el-form-item v-if="component.componentType === 'rc-coding'" label="表格内重排">
      <el-checkbox v-model="component.properties.code.isRestart"></el-checkbox>
    </el-form-item>
    <calculation-panel
      :dialogVisible.sync="dialogVisible"
      :expression="component.properties.code.expression"
      :dataSource="getDataSource"
      @getExpression="getExpression"
      @close="dialogVisible = false"></calculation-panel>
  </div>
</template>

<script>
import CalculationPanel from '../../shared/calculation-panel.vue'
import { calculateMixin } from '../components/mixins'

export default {
  name: 'attr-code',
  props: [ 'component' ],
  mixins: [ calculateMixin ],
  inject: ['formService'],
  components: { CalculationPanel },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    validateNumber  (rule, value, callback) {
      if (rule.options.startNumber.length > rule.options.length) {
        callback(new Error(`请输入${rule.options.length}位数及以下数字`))
      }
      callback()
    },
    validateCodeLength (rule, value, callback) {
      if (rule.options.length <= 0) {
        callback(new Error(`请输入大于0的整数`))
      }
      callback()
    },
    // 打开计算弹窗
    focus () {
      this.dialogVisible = true
    },
    // 根据弹窗传值公式处理需要保存的数据
    getExpression (expression) {
      this.component.properties.code.expression = expression
    }
  },
  computed: {
    show () {
      return this.component.properties.code.startNumber.padStart(this.component.properties.code.length, '0')
    },
    expressionShow () {
      return this.expressionToWithCode(this.component.properties.code.expression)
    }
  }
}
</script>

<style lang="scss">
  .prefix {
    .formula {
      position: absolute;
      margin-top: -14px;
      padding: 0 10px;
      top: 50%;
      outline: none;
      border: 1px solid #e4e7ed;
      background: #fff;
      border-radius: 4px;
      max-height: 80px;
      overflow: hidden;
      width: 100%;
      height: 28px;
      line-height: 28px;
      code {
        padding: 2px 4px;
        font-size: 90%;
        color: #c7254e;
        background-color: #f9f2f4;
        border-radius: 4px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/code.vue